<template>
  <div class="default-blank">
    <Blank text="功能升级维护中，敬请期待。" />
  </div>
</template>

<script>
import Blank from '../chargingVoucher/components/Blank.vue';

export default {
  name: 'DefaultBlank',
  components: {
    Blank
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.default-blank {
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
